<!--期权-->
<template>
	<div class="page-body">
		<div class="info-wrap">
			<div class="left">
				<div class="zfss">
					<div class="bz">
						<img :src="productInfo.image" class="bz-img">
						<span>{{ productInfo.title }}</span>
					</div>
					<div class="icon-box">
						<i class="el-icon-star-on" :style="{ color: productInfo.selected == 1 ? '#f0c163' : '' }"></i>
					</div>
					<div class="rmyg">
						<span class="jg green">{{ productInfo.price }}</span>
						<!-- <span class="asd">≈ $ 116.490000</span> -->
					</div>
				</div>
				<div class="dadas">
					<div class="rmyg">
						<span class="dsad">{{ $t('涨幅') }}</span>
						<span class="asd csafdas" :style="{ color: productInfo.price_zf > 0 ? '#00f0ff' : '#ff4834' }">
							{{ productInfo.price_zf }}%</span>
					</div>
					<div class="rmyg">
						<span class="sds">{{ $t('最高价') }}</span>
						<span class="asd">{{ productInfo.price_high }}</span>
					</div>
					<div class="rmyg">
						<span class="sds">{{ $t('最低价') }}</span>
						<span class="asd">{{ productInfo.price_low }}</span>
					</div>
					<div class="rmyg">
						<span class="sds">{{ $t('24H量') }}</span>
						<span class="asd">{{ productInfo['24hl'] }}k</span>
					</div>
					<div class="rmyg">
						<span class="sds">{{ $t('24H交易额') }}</span>
						<span class="asd">{{ productInfo['24hjye'] }}b</span>
					</div>
				</div>
			</div>
			<div class="r-time"> {{ currentTime }} </div>
		</div>

		<div class="dis-fle">
			<modelLeft @changeCode="changeCode"></modelLeft>
			<div class="flex-1">
				<div class="dis-fle">
					<div class="center-page flex-1">

						<el-tabs v-model="textActive" type="card" @tab-click="handleClick">
							<el-tab-pane :label="$t('期权')" name="1"></el-tab-pane>
							<el-tab-pane :label="$t('现货')" name="2"></el-tab-pane>
							<el-tab-pane :label="$t('合约')" name="3"></el-tab-pane>
						</el-tabs>

						<eChart :productInfo="productInfo" :code="code"></eChart>

						<component :is="comForm" ref="comFormRef" :productInfo="productInfo" :money="money"
							:moneyAccount="moneyAccount" @initList="initList" @modify="getUserMoney"></component>
					</div>
					<modelRight ref="modelRightRef" :productInfo="productInfo"></modelRight>
				</div>
				<component :is="comList" ref="comListRef" :id="productInfo.id" @modify="getUserMoney"></component>
			</div>
		</div>
	</div>
</template>
<script>
import { getQueryParam } from '@/common/public.js';
import { get } from '@/http/request'

import modelLeft from './components/left.vue';
import modelRight from './components/right.vue';
import eChart from './components/eChart.vue';
//期权
import tradeForm from './components/tradeForm.vue';
import tradeList from './components/tradeList.vue';
//现货
import spotGoodsForm from './components/spotGoodsForm.vue';
import spotGoodsList from './components/spotGoodsList.vue';
//合约
import contractForm from './components/contractForm.vue';
import contractList from './components/contractList.vue';
export default {

	components: {
		modelLeft,
		modelRight,
		eChart
	},
	props: {
		// 1=期权 3=合约 2=现货
		type: {
			type: [String, Number],
			default: ''
		},
	},
	watch: {
		type: {
			handler(value) {
				if (value == 1) {
					this.comForm = tradeForm
					this.comList = tradeList
				} else if (value == 2) {
					this.comForm = spotGoodsForm
					this.comList = spotGoodsList
				} else {
					this.comForm = contractForm
					this.comList = contractList
				}
				console.log(value)
				this.textActive = String(value)
			},
			// deep: true, // 开启深度监听
			immediate: true // 可选：立即触发一次
		},
		activeName(newVal, oldVal) {
			console.log(newVal)
			this.prevActive = oldVal; // 记录点击前的选中项
		}
	},
	data() {
		return {
			currentTime: '',
			timer: null,

			money: 0,
			moneyAccount: 0,
			code: getQueryParam('code'),

			productInfo: {},

			comForm: null,
			comList: null,

			textActive: '1',
			prevActive: '1',
		};
	},
	created() {
		if (this.code) {
			this.getProductInfo()
		}

		this.getUserMoney()
	},
	methods: {

		handleClick() {
			if (this.prevActive == this.textActive) return
			if (this.textActive == '1') {
				this.$nav.go('/pc/trade')
			} else if (this.textActive == '2') {
				this.$nav.go('/pc/spotGoods')
			} else if (this.textActive == '3') {
				this.$nav.go('/pc/contract')
			}
		},
		changeCode(code) {
			if (code != this.code) {
				this.code = code
				this.getProductInfo()
			}
		},
		//获取数据
		getProductInfo() {
			get(this.$apis.getProductInfo, {
				code: this.code
			}).then(res => {
				if (res.code != 1) return
				this.productInfo = res.data

				//获取右侧数据
				this.$nextTick(() => {
					this.$refs.modelRightRef.init({
						product_id: this.productInfo.id,
						code: this.productInfo.code,
						//1=期权合约2=现货
						label: this.type == 2 ? 2 : 1
					})
				})
			})
		},
		getUserMoney() {
			get(this.$apis.getUserInfo, {
				showLoading: false
			}).then(res => {
				if (res.code != 1) return
				this.money = Number(res.data.spot_account_default)
				this.moneyAccount = Number(res.data.contract_account)
			})
		},

		initList() {
			this.$refs.comListRef.init()
		},
		// 格式化时间
		formatTime(date) {
			const Y = date.getFullYear();
			const M = date.getMonth() + 1; // 月份从0开始
			const D = date.getDate();
			const h = date.getHours();
			const m = date.getMinutes();
			const s = date.getSeconds();
			return `${Y}/${M}/${D} ${this.pad(h)}:${this.pad(m)}:${this.pad(s)}`;
		},
		pad(num) {
			return num < 10 ? '0' + num : num;
		},
		updateTime() {
			const now = new Date();
			this.currentTime = this.formatTime(now);
		}
	},
	mounted() {
		this.updateTime(); // 页面加载立即显示时间
		this.timer = setInterval(this.updateTime, 1000); // 每秒更新
	},
	beforeDestroy() {
		// 清理定时器
		if (this.timer) {
			clearInterval(this.timer);
			this.timer = null;
		}
	}
};
</script>
<style lang="scss" scoped>
.page-body {

	::v-deep .el-tabs--card {

		.el-tabs__header,
		.el-tabs__nav,
		.el-tabs__item {
			border-color: #2c2c3e !important;
		}

		.el-tabs__nav {
			border-left-width: 0px;
			border-radius: 0px 4px 0 0;
		}

		.is-active {
			color: var(--color-txt1) !important;
		}

		.el-tabs__header {
			margin-bottom: 0px;
		}
	}

	.center-page {
		border-left: 1px solid #2c2c3e;
		border-right: 1px solid #2c2c3e;
		min-height: 100vh;
	}

	.info-wrap {
		padding-left: 20px;
		display: flex;
		align-items: center;
		color: #c7cce6;
		padding: 13px 10px;
		color: #888;
		border-color: #2c313e;

		.left {
			flex: 1;
			display: flex;
			align-items: center;

			.dadas {
				display: flex;
				align-items: center;

				.rmyg {
					padding: 0 32px;
					text-align: center;
					display: flex;
					flex-direction: column;
					justify-content: center;
					color: #999;

					span {
						font-size: 12px;
						line-height: 22px;
					}
				}
			}

			.zfss {
				display: flex;
				align-items: center;

				.rmyg {
					padding: 0 32px;
					text-align: center;
					display: flex;
					flex-direction: column;
					justify-content: center;
					color: #999;

					.asd {
						font-size: 12px;
						line-height: 26px;
					}
				}

				.icon-box {
					width: 24px;
					height: 24px;
					background: #141427;
					border: 1px solid #2c2c3e;
					border-radius: 4px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					position: relative;
				}

				.bz {
					border-color: #2c313e;
					font-size: 18px;
					display: flex;
					align-items: center;
					flex-direction: row;
					padding: 0 1.5rem;
					margin-right: 1rem;
					color: #fff;

					.bz-img {
						width: 24px;
						height: 24px;
						margin-right: 5px;
					}
				}
			}
		}

		.r-time {
			color: #fff;
			padding-right: 40px;
			font-size: 12px;
		}
	}

	.green {
		color: #00f0ff !important;
	}

	.asd {
		color: #888;
	}
}
</style>